export default __webpack_public_path__ + "media/images/defaultmascot-a8a1e852f81e0abf67ab1e850cc78cb1.svg";